<template>
  <div class="ap-sub-panel">
    <div class="ap-query-row">
      <el-form :model="udQuery" label-position="left" label-width="150px" class="ap-query" inline @keyup.enter.native="searchUd">
        <el-form-item label="Device Name / Model" style="margin-right: 18px">
          <el-input clearable size="small" v-model="udQuery.deviceNameModel" placeholder="Please input" style="width:180px"></el-input>
        </el-form-item>
        <el-form-item label="Under Warranty" label-width="110px">
          <el-select clearable size="small" v-model="udQuery.underWarranty" placeholder="Please select" style="width:180px">
            <el-option label="Yes" :value="true"></el-option>
            <el-option label="No" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="ap-query-actions">
        <el-button type="primary" size="small" @click="searchUd">Search</el-button>
        <el-button size="small" @click="resetUd">Reset</el-button>
        <el-button size="small" :loading="udExportLoading" @click="exportUd">Export</el-button>
        <el-button v-if="hasOperationPermission" type="primary" size="small" @click="addUd">+ Add</el-button>
      </div>
    </div>
    <el-table :data="udTableData" size="small" border style="width:100%" :header-cell-style="{background:'#F5F5F9'}" @sort-change="udSortChange" v-loading="udLoading">
      <el-table-column label="No" width="65" align="center">
        <template slot-scope="scope">{{ (udPage - 1) * udPageSize + scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column prop="deviceNameModel" label="Device Name / Model" min-width="220" sortable="custom" align="left" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="deviceQuantity" label="Device Quantity" min-width="155" sortable="custom" align="center"></el-table-column>
      <el-table-column prop="underWarranty" label="Under Warranty" min-width="155" sortable="custom" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.underWarranty !== null && scope.row.underWarranty !== undefined && scope.row.underWarranty !== ''" :class="['ap-tag', 'ap-tag-' + warrantyTagClass(scope.row.underWarranty)]">{{ scope.row.underWarranty === true ? 'Yes' : 'No' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedBy" label="Modifier" min-width="130" sortable="custom" align="center"></el-table-column>
      <el-table-column prop="updatedTime" label="Modified Time" min-width="150" sortable="custom" align="center"></el-table-column>
      <el-table-column v-if="hasOperationPermission" label="Operation" width="170" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="modifyUd(scope.row)">Modify</el-button>
          <el-button type="danger" size="mini" @click="deleteUd(scope.row)" style="margin-left:5px">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="ap-pagination">
      <span class="ap-pagination-total">Total {{ udTotal }}</span>
      <el-pagination small layout="prev, pager, next, sizes" :total="udTotal" :current-page.sync="udPage" :page-sizes="[10,20,50]" :page-size.sync="udPageSize" @current-change="v => { udPage = v; loadUdData() }" @size-change="v => { udPageSize = v; udPage = 1; loadUdData() }"></el-pagination>
    </div>

    <!-- UD Add/Modify Modal -->
    <el-dialog :title="udDialogTitle" :visible.sync="udDialogVisible" width="500px" custom-class="ud-dialog">
      <el-form :model="udForm" ref="udForm" label-position="top" label-width="150px" :rules="udRules">
        <el-form-item label="Device Name / Model" prop="deviceNameModel">
          <el-input size="small" v-model="udForm.deviceNameModel" placeholder="Please input" clearable></el-input>
        </el-form-item>
        <el-form-item label="Device Quantity">
          <el-input size="small" v-model.number="udForm.deviceQuantity" type="number" placeholder="Please input" style="width:100%" clearable></el-input>
        </el-form-item>
        <el-form-item label="Under Warranty">
          <el-select size="small" v-model="udForm.underWarranty" placeholder="Please select" style="width:100%" clearable>
            <el-option label="Yes" :value="true"></el-option>
            <el-option label="No" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="udDialogVisible = false">Cancel</el-button>
        <el-button type="primary" size="small" :loading="udSaving" @click="saveUd" style="margin-left: 6px">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AccountProfileUninspectedDev',
  props: {
    accountInfo: { type: Object, default: () => ({}) },
    hasOperationPermission: { type: Boolean, default: false }
  },
  data() {
    return {
      udQuery: { deviceNameModel: '', underWarranty: '' },
      udTableData: [],
      udLoading: false,
      udTotal: 0,
      udPage: 1,
      udPageSize: 10,
      udSortField: '',
      udSortOrder: '',
      udExportLoading: false,
      udDialogVisible: false,
      udDialogTitle: 'Add',
      udEditId: null,
      udSaving: false,
      udForm: { deviceNameModel: '', deviceQuantity: '', underWarranty: '' },
      udRules: { deviceNameModel: [{ required: true, message: 'Please enter Device Name / Model', trigger: 'blur' }] },
    }
  },
  created() {
    this.loadUdData()
  },
  watch: {
    'accountInfo.id'(newVal) {
      if (newVal) this.loadUdData()
    }
  },
  methods: {
    loadData() {
      this.loadUdData()
    },
    warrantyTagClass(v) { return v === true ? 'green' : (v === false ? 'red' : '') },
    _sortFieldMap(prop) {
      const map = { deviceNameModel: 'deviceNameModel', deviceQuantity: 'deviceQuantity', underWarranty: 'underWarranty', updatedBy: 'updatedBy', updatedTime: 'updatedTime' }
      return map[prop] || prop
    },
    loadUdData() {
      const id = this.accountInfo.id
      if (!id) return
      let params = {
        pageNum: this.udPage,
        pageSize: this.udPageSize,
        deviceNameModel: this.udQuery.deviceNameModel || undefined,
        underWarranty: this.udQuery.underWarranty !== '' ? this.udQuery.underWarranty : undefined,
        sortField: this.udSortField ? this._sortFieldMap(this.udSortField) : undefined,
        sortOrder: this.udSortOrder === 'ascending' ? 'asc' : (this.udSortOrder === 'descending' ? 'desc' : undefined),
      }
      Object.keys(params).forEach(key => { if (params[key] === undefined || params[key] === '') delete params[key] })

      this.udLoading = true
      let url = `${this.$store.state.islhurl}valued-account/profile/${id}/uninspected-devices`
      this.$axios.get(url, { params }).then(res => {
        this.udLoading = false
        const data = res.data
        if (data.code === 200) {
          this.udTableData = data.data || []
          this.udTotal = data.totalSize || 0
        } else {
          this.udTableData = []
          this.udTotal = 0
          this.$message.error(data.msg || 'Failed!')
        }
      }).catch(() => {
        this.udLoading = false
        this.udTableData = []
        this.udTotal = 0
      })
    },
    searchUd() { this.udPage = 1; this.loadUdData() },
    resetUd() { this.udQuery = { deviceNameModel: '', underWarranty: '' }; this.udSortField = ''; this.udSortOrder = ''; this.udPage = 1; this.loadUdData() },
    udSortChange({ prop, order }) { this.udSortField = order ? (prop || '') : ''; this.udSortOrder = order || ''; this.udPage = 1; this.loadUdData() },
    addUd() { this.udEditId = null; this.udDialogTitle = 'Add Uninspected Device'; this.udForm = { deviceNameModel: '', deviceQuantity: '', underWarranty: '' }; this.udDialogVisible = true; this.$nextTick(() => this.$refs.udForm && this.$refs.udForm.clearValidate()) },
    modifyUd(row) { this.udEditId = row.id; this.udDialogTitle = 'Modify Uninspected Device'; this.udForm = { deviceNameModel: row.deviceNameModel, deviceQuantity: row.deviceQuantity, underWarranty: row.underWarranty }; this.udDialogVisible = true; this.$nextTick(() => this.$refs.udForm && this.$refs.udForm.clearValidate()) },
    saveUd() {
      this.$refs.udForm.validate(valid => {
        if (!valid) return
        const id = this.accountInfo.id
        this.udSaving = true
        let url = `${this.$store.state.islhurl}valued-account/profile/${id}/uninspected-devices`
        let method = 'post'
        if (this.udEditId) {
          url += `/${this.udEditId}`
          method = 'put'
        }
        this.$axios({ url, method, data: { deviceNameModel: this.udForm.deviceNameModel, deviceQuantity: this.udForm.deviceQuantity, underWarranty: this.udForm.underWarranty } }).then(res => {
          this.udSaving = false
          const data = res.data
          if (data.code === 200) {
            this.$message.success('Saved successfully!')
            this.udDialogVisible = false
            this.loadUdData()
          } else {
            this.$message.error(data.msg || 'Save failed!')
          }
        }).catch(() => {
          this.udSaving = false
          this.$message.error('Save failed!')
        })
      })
    },
    deleteUd(row) {
      this.$confirm('Confirm to delete this item?', 'Confirm', { type: 'warning' }).then(() => {
        const id = this.accountInfo.id
        let url = `${this.$store.state.islhurl}valued-account/profile/${id}/uninspected-devices/${row.id}`
        this.$axios.delete(url).then(res => {
          const data = res.data
          if (data.code === 200) {
            this.$message.success('Deleted successfully!')
            this.udPage = 1
            this.loadUdData()
          } else {
            this.$message.error(data.msg || 'Delete failed!')
          }
        }).catch(() => { this.$message.error('Delete failed!') })
      }).catch(() => {})
    },
    exportUd() {
      const id = this.accountInfo.id
      if (!id) return
      this.udExportLoading = true
      let params = {
        deviceNameModel: this.udQuery.deviceNameModel || undefined,
        underWarranty: this.udQuery.underWarranty !== '' ? this.udQuery.underWarranty : undefined,
      }
      Object.keys(params).forEach(key => { if (params[key] === undefined || params[key] === '') delete params[key] })
      this.$axios({
        url: `${this.$store.state.islhurl}valued-account/profile/${id}/uninspected-devices/export`,
        method: 'get',
        params,
        responseType: 'blob'
      }).then(response => {
        this.udExportLoading = false
        const blob = new Blob([response.data])
        const aEle = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        aEle.href = href
        aEle.download = 'UninspectedDevices_' + new Date().toISOString().slice(0, 10) + '.xlsx'
        document.body.appendChild(aEle)
        aEle.click()
        document.body.removeChild(aEle)
        window.URL.revokeObjectURL(href)
      }).catch(() => {
        this.udExportLoading = false
        this.$message.error('Export failed!')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.ap-sub-panel {
  .ap-query-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 8px;
    .ap-query {
      flex: 1;
      /deep/ .el-form-item { margin-bottom: 0; }
      /deep/ .el-form-item__label { font-size: 13px; color: #1F2937; }
      /deep/ .el-form-item__content .el-input__suffix {
        left: auto;
        right: 10px;
      }
    }
    .ap-query-actions {
      display: flex;
      align-items: center;
      gap: 8px;
      padding-top: 4px;
      white-space: nowrap;
    }
  }
  .ap-tag {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 3px;
    font-size: 12px;
    line-height: 20px;
    &.ap-tag-green { color: #52C41A; }
    &.ap-tag-blue { color: #1890FF; }
    &.ap-tag-orange { color: #FA8C16; }
    &.ap-tag-red { color: #F5222D; }
    &.ap-tag-gray { color: #8C8C8C; }
  }
  .ap-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 12px 0 0;
    gap: 12px;
    .ap-pagination-total {
      font-size: 13px;
      color: #6B7280;
    }
  }
}
.el-button+.el-button {
  margin-left: 0;
}
</style>

<style>
.ud-dialog .el-dialog__body {
  padding: 10px 20px;
}
.ud-dialog .el-form-item {
  margin-bottom: 0;
}
.ud-dialog .el-form-item__content .el-input__suffix {
  left: auto;
  right: 10px;
}
.ud-dialog .el-form--label-top .el-form-item__label {
  line-height: 28px;
  padding-bottom: 0;
  padding-top: 5px;
}
.ud-dialog .el-form-item__error {
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/valuedAccountManagement/accountDetailTabs/AccountProfileUninspectedDev.vue